/* WITS quiz -> landing handoff. No quiz answers or customer details are stored or published. */
(function(root){
'use strict';
const KEY='wits:quiz:landing-handoff:v1:production',PARAM='wits_qid',TTL=30*60*1000;
let publishing=false;
const read=()=>{try{return JSON.parse(root.sessionStorage.getItem(KEY))}catch(_){return null}};
const save=r=>{try{root.sessionStorage.setItem(KEY,JSON.stringify(r));return true}catch(_){return false}};
const status=s=>document.documentElement.setAttribute('data-wits-quiz-event',s);
root.WITSQuizTracking=Object.freeze({
 mode:'shopify',
 begin(href){
  const destination=new URL(href,root.location.href);
  if(destination.origin!==root.location.origin)return href;
  destination.searchParams.delete(PARAM);
  let r=read();
  if(!r||r.destination!==destination.origin+destination.pathname||Date.now()-r.created_at>TTL){
   r={event_name:'WITSQuizCompleted',event_id:'wits_quiz_'+root.crypto.randomUUID(),created_at:Date.now(),destination:destination.origin+destination.pathname,status:'pending'};
  }
  if(!save(r))return href;
  destination.searchParams.set(PARAM,r.event_id);return destination.href;
 },
 async confirmArrival(){
  const url=new URL(root.location.href),token=url.searchParams.get(PARAM),r=read();
  if(!token||!r||r.event_id!==token||r.destination!==url.origin+url.pathname||Date.now()-r.created_at>TTL){return false;}
  if(r.status==='published'){url.searchParams.delete(PARAM);root.history.replaceState(root.history.state,'',url.href);status('already-published');return true;}
  if(publishing)return false;
  if(typeof root.Shopify?.analytics?.publish!=='function'){status('waiting-for-shopify');return false;}
  publishing=true;
  try{
   const accepted=await root.Shopify.analytics.publish('wits:quiz_landing_arrived',{event_id:r.event_id,quiz_id:'wits_focus',quiz_version:'2'});
   if(accepted===false){status('publish-not-accepted');return false;}
   r.status='published';r.arrived_at=Date.now();save(r);
   url.searchParams.delete(PARAM);root.history.replaceState(root.history.state,'',url.href);
   status('published-to-shopify');return true;
  }catch(_){status('publish-error');return false;}finally{publishing=false;}
 },
 snapshot(){return read()}
});
})(window);
